import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { ChartJobFieldDto } from 'src/app/types/dto/chart-job-field.dto'
import { environment } from 'src/environments/environment'
import { AuthService } from '../auth.service'
import { HttpHelperService } from '../http.service'
import { TimedCache } from '../timed-cache'

@Injectable({
  providedIn: 'root',
})
export class JobFieldsApiService {
  private httpHelper = inject(HttpHelperService);
  private auth = inject(AuthService);
  private http = inject(HttpClient);

  private cache = new TimedCache<ChartJobFieldDto[]>()

  getJobFieldValues(dataField: string): Observable<ChartJobFieldDto[]> {
    const compId = this.auth.getCurrentCompany()?.id ?? 0
    return this.cache.get(`${compId}_${dataField}`, () =>
      this.http.get<ChartJobFieldDto[]>(
        `${environment.apiUrl}job-fields-for-charts?dataField=${encodeURIComponent(dataField)}`,
        this.httpHelper.httpReadOnlyOptions
      )
    )
  }
}
